import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./login.module.css";

export default function Login({
  login,
  password,
  setLogin,
  setPassword,
  loginRef,
  passwordRef,
  handleLogin,
  isLoading,
  handleKeyDown,
}) {
  const { t } = useTranslation();
  const [isShowPassword, setIsShowPassword] = useState(false);

  const handleShowPassword = () => {
    setIsShowPassword(!isShowPassword);
  }

  const passIcon = isShowPassword ? "fas fa-lock-open" : "fa fa-lock";


  return (
    <form className={styles.AuthoritionBlock}>
      <h3>{t("login.title")}</h3>

      <div className={styles.inputWrapper}>
        <input
          type="text"
          placeholder={t("login.login")}
          name="login"
          value={login}
          onChange={(e) => setLogin(e.target.value)}
          ref={loginRef}
          onKeyDown={handleKeyDown}

        />
        <i className="fas fa-user"></i>
      </div>

      <div className={styles.inputWrapper}>
        <input
          type={isShowPassword ? "text" : "password"}
          placeholder={t("login.password")}
          name="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          ref={passwordRef}
          onKeyDown={handleKeyDown}

        />
        <i className={passIcon} onClick={handleShowPassword} style={{ cursor: 'pointer' }}></i>
      </div>

      <button onClick={handleLogin}>
        {isLoading ? t("loading") : t("login.sign")}
      </button>
    </form>
  );
}
